import firebase from 'firebase/app';
import 'firebase/database';
import 'firebase/firestore';
var config = {
  apiKey: "AIzaSyD3QNSYO8LNhP7cF2JaGoZ6ys1BZZhf8Co",
  authDomain: "ahlalquran.firebaseapp.com",
  databaseURL: "https://ahlalquran.firebaseio.com",
  projectId: "ahlalquran",
  storageBucket: "ahlalquran.appspot.com",
  messagingSenderId: "318771848534"
};
var fire = firebase.initializeApp(config);
export default fire;
